import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import CapabilitiesPage from '@/pages/CapabilitiesPage';
import ProjectsPage from '@/pages/ProjectsPage';
import IndustriesPage from '@/pages/IndustriesPage';
import InsightsPage from '@/pages/InsightsPage';
import CareersPage from '@/pages/CareersPage';
import NotFoundPage from '@/pages/NotFoundPage';

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route serves main landing page */}
        <Route path="/" element={<HomePage />} />

        {/* Home route alias redirects to / */}
        <Route path="/home" element={<Navigate to="/" replace />} />

        {/* Additional Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/capabilities" element={<CapabilitiesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/careers" element={<CareersPage />} />

        {/* Catch-all 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
